import React, { useMemo } from "react";
import { getActivityTypePillToken } from "../config/palette";
import { SingleSelectPillField } from "./SingleSelectPillField";

export interface ActivityTemplateFilterOption {
  id: string;
  name: string;
  activityType?: string;
}

export function ActivityTemplateFilterField({
  id,
  value,
  options,
  activityTypeByTemplateId,
  onChange,
  disabled = false,
}: {
  id: string;
  value: string;
  options: readonly ActivityTemplateFilterOption[];
  activityTypeByTemplateId?: ReadonlyMap<string, string>;
  onChange: (value: string) => void;
  disabled?: boolean;
}) {
  const selectOptions = useMemo(
    () => [
      {
        id: `${id}-all`,
        value: "",
        label: "All Activity Templates",
      },
      ...options.map((option) => ({
        id: `${id}-${option.id}`,
        value: option.id,
        label: option.name,
        colorKey:
          option.activityType || activityTypeByTemplateId?.get(option.id) || "",
      })),
    ],
    [activityTypeByTemplateId, id, options],
  );

  return (
    <div className="cp-report-filter-field">
      <span>Activity Template</span>
      <SingleSelectPillField
        id={id}
        value={value}
        options={selectOptions}
        onChange={onChange}
        ariaLabel="Activity Template"
        placeholder="All Activity Templates"
        searchPlaceholder="Search Activity Templates"
        emptyMessage="No Activity Templates found"
        resolveColor={(option) =>
          option.value
            ? getActivityTypePillToken(option.colorKey ?? "")
            : "neutral"
        }
        disabled={disabled}
      />
    </div>
  );
}
